import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.scanner-license';
import * as api from '../../../clients/api';

@Injectable()
export class ApiScannerLicenseEffects {

    ScannerLicense$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_SCANNER_LICENSE),
        mergeMap((x: ac.GetScannerLicenseAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getScannerLicense(x.device_id, x.app_id).pipe(
                map((result: any) => {
                    return new ac.GetScannerLicenseErfolgreichAction(result, x.device_id, x.app_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetScannerLicenseFehlerAction(error, x.device_id, x.app_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
